import { render, staticRenderFns } from "./InscribetePage.vue?vue&type=template&id=478e710a&"
import script from "./InscribetePage.js?vue&type=script&lang=js&"
export * from "./InscribetePage.js?vue&type=script&lang=js&"
import style0 from "./InscribetePage.vue?vue&type=style&index=0&id=478e710a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports